export const SET_BLOCKS = 'setBlocks';
export const TOGGLE_SIGNATURE = 'toggleSignature';
export const SET_TITLE = 'setTitle';
export const EDIT_MODE = 'editMode';
export const RESET_BLOCK = 'resetBlock';
export const SELECTED_TEMPLATE = 'selectedTemplate';
export const SET_TEMPLATE_ID='setTemplateId'
